/* eslint-disable import/prefer-default-export */

import { map } from 'lodash'
import { AccountInfo } from '@src/endpoints/services/base.service'
import type { PrivilegeSummary } from '@src/endpoints/services/graphQueryMgr.service'
import { getAccountNameById } from '@src/utils/accounts'
import {
  getNameAndType,
  getSeparatorByAccountId
} from '@src/utils/privileges.utils'

export const parsePrivilege = (
  item: PrivilegeSummary,
  account_info: AccountInfo[]
) => ({
  ...item,
  action: item.name,
  users_ut: `${item.users_unused || 0}/${item.users_total || 0}`,
  historical_usage: `${item.used_90 || 0}/${item.used_30 || 0}/${
    item.used_7 || 0
  }`,
  account_name: getAccountNameById(item.account_id, account_info),
  ...getNameAndType(item.name, getSeparatorByAccountId(item.name, account_info))
})

export const parsePrivilegesSummary = (
  data: PrivilegeSummary[],
  account_info: AccountInfo[]
) => map(data || [], x => parsePrivilege(x, account_info))
